import { create } from 'zustand'

interface SyncProgressStore {
  syncing: boolean
  progress: number   // 0–100
  label: string
  start: () => void
  setProgress: (p: number, label: string) => void
  done: () => void
}

export const useSyncProgressStore = create<SyncProgressStore>((set) => ({
  syncing: false,
  progress: 0,
  label: '',
  start: () => set({ syncing: true, progress: 0, label: 'Syncing…' }),
  setProgress: (p, label) => set({ progress: p, label }),
  done: () => set({ syncing: false, progress: 100 }),
}))
